import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-football-team__head"
}
const _hoisted_2 = { class: "as-football-team__body" }
const _hoisted_3 = {
  key: 0,
  class: "as-team-img"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "as-team-info" }
const _hoisted_6 = { class: "as-team" }
const _hoisted_7 = {
  key: 1,
  class: "as-team-info__result"
}
const _hoisted_8 = {
  key: 1,
  class: "as-team-info as-team-info__only-name"
}
const _hoisted_9 = {
  key: 2,
  class: "as-team-info as-team-info__only-state"
}

import type { IMatch } from "~src/interfaces";
import type {
  IFootyStats,
  IPreviousMatchId,
  IStatsParent,
} from "~src/interfaces/footystats";
import { getImageUrl } from "~src/helpers/footystats";
import { computed, onMounted, ref } from "vue";


const __default__ = {};

interface Props {
  match: IMatch;
  footyStats: IFootyStats | null;
  modeTeam?: string;
  mode?: string;
  modifyClass?: string;
  showName?: boolean;
  showOnlyName?: boolean;
  showLogo?: boolean;
  showStatus?: boolean;
  showResult?: boolean;
  showState?: boolean;
  status?: string;
  homePoint?: number;
  awayPoint?: number;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FootballTeamItem',
  props: {
    match: {},
    footyStats: { default: null },
    modeTeam: { default: "" },
    mode: { default: "" },
    modifyClass: { default: "" },
    showName: { type: Boolean, default: true },
    showOnlyName: { type: Boolean, default: false },
    showLogo: { type: Boolean, default: true },
    showStatus: { type: Boolean, default: true },
    showResult: { type: Boolean, default: true },
    showState: { type: Boolean, default: false },
    status: { default: "as-D" },
    homePoint: { default: 0 },
    awayPoint: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

const fivePreviousMatches = ref<IPreviousMatchId[] | []>([]);
onMounted(() => {
  if (props.footyStats && props.footyStats?.h2h) {
    if (
      props.footyStats?.h2h?.previous_matches_results &&
      props.footyStats?.h2h?.previous_matches_ids
    ) {
      fivePreviousMatches.value =
        props.footyStats.h2h.previous_matches_ids.slice(0, 5);
    }
  }
});

const setClassForTeamItem = (home: number, away: number, mode = "home") => {
  let __class = "";
  let num_1 = home;
  let num_2 = away;
  if (mode === "as-away") {
    num_1 = away;
    num_2 = home;
  }
  if (num_1 > num_2) {
    __class = "W";
  } else if (num_1 < num_2) {
    __class = "L";
  } else {
    __class = "D";
  }
  return __class;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-football-team ${_ctx.modeTeam} ${_ctx.modifyClass}`)
  }, [
    (_ctx.showName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.modeTeam == "as-away" ? _ctx.footyStats?.away_name : _ctx.footyStats?.home_name) + " " + _toDisplayString(_ctx.modeTeam == "as-away" ? "(Đội khách)" : "(Đội nhà)"), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "as-team-img__logo",
              src: 
            _unref(getImageUrl)(
              _ctx.modeTeam == 'as-away'
                ? _ctx.footyStats?.away_image
                : _ctx.footyStats?.home_image
            )
          
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.showStatus)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`as-team-info__point as-${setClassForTeamItem(
            _ctx.homePoint,
            _ctx.awayPoint,
            _ctx.modeTeam
          )}`)
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.modeTeam == "as-away" ? _ctx.awayPoint : _ctx.homePoint), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.showResult && fivePreviousMatches.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fivePreviousMatches.value, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: _normalizeClass(`as-${setClassForTeamItem(
              item.team_a_goals,
              item.team_b_goals,
              _ctx.modeTeam
            )}`),
                  key: index
                }, _toDisplayString(setClassForTeamItem(
                item.team_a_goals,
                item.team_b_goals,
                _ctx.modeTeam
              )), 3))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showOnlyName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.modeTeam == "as-away" ? _ctx.footyStats?.away_name : _ctx.footyStats?.home_name), 1))
        : _createCommentVNode("", true),
      (_ctx.showState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Hiệp 1 "))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})